import { Button, DialogTitle, FormControlLabel, Switch } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CommonUrl, NONCE, processMsg, TIME_STAMP } from '../../../common-url/CommonUrl'



export default function FirmwareFileForm({ data, firmware }) {

    const [formData, setFormData] = useState({ tiStatus: 0 });
    const [selectedFile, setSelectedFile] = useState();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [group, setGroup] = useState([])
    const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);

    const disableProductGroup = (firmware) => {
        var temp = []
        const data1 = firmware?.map((ele) => {
            if (ele?.vProductGroup === "smartouch_4M") {
                temp.push("smartouch_4M")
            }
            else if (ele?.vProductGroup === "smartouch_8M") {
                temp.push("smartouch_8M")
            }
            else if (ele?.vProductGroup === "smartack") {
                temp.push("smartack")
            }
            else if (ele?.vProductGroup === "smartap_1_15A") {
                temp.push("smartap_1_15A")
            }
            else if (ele?.vProductGroup === "smartap_1_5A") {
                temp.push("smartap_1_5A")
            }
            else if (ele?.vProductGroup === "smartap_4M") {
                temp.push("smartap_4M")
            }
            else if (ele?.vProductGroup === "smartap_8M") {
                temp.push("smartap_8M")
            }
        })
        setGroup(temp)
    }

    useEffect(() => {
        disableProductGroup(firmware)
    }, [])

    useEffect(() => {
        data && data._id && setFormData(data)
    }, []);

    const handleCloseSuccess = () => {
        history.push("/firmware-file")
    }


    // ------------------------------------------------------------
    //                          update
    // ------------------------------------------------------------

    const onFormUpdate = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        const data = new FormData();
        data.append("_id", formData._id);
        data.append("vFileDetails", selectedFile);
        data.append("vTitle", formData.vTitle);
        data.append("vDescription", formData.vDescription);
        data.append("vProductGroup", formData.vProductGroup);
        data.append("vVersion", formData.vVersion);
        data.append("tiStatus", formData.tiStatus);
        data.append("vFileName", formData.vFileName);

        fetch(CommonUrl.firmwareBaseUrl + "/update", {
            method: "put",
            body: data,
            headers: {
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP
            }
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 })
                setLoading(false);
                handleCloseSuccess();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 })
                setTimeout(() => {
                    setLoading(false);
                }, 3000)
            }
        })
    }


    // ------------------------------------------------------------
    //                          add
    // ------------------------------------------------------------

    const onFormAdd = (e) => {
        e.preventDefault();
        setLoading(true);
        const id = toast.loading(processMsg);
        const data = new FormData();
        data.append("vFileDetails", selectedFile);
        data.append("vTitle", formData.vTitle);
        data.append("vDescription", formData.vDescription);
        data.append("vProductGroup", formData.vProductGroup);
        data.append("vVersion", formData.vVersion);
        data.append("tiStatus", formData.tiStatus)

        fetch(CommonUrl.firmwareBaseUrl + "/add", {
            method: "post",
            body: data,
            headers: {
                'token': encToken,
                'nonce': NONCE,
                'timestamp': TIME_STAMP,
            }
        }).then(response => response.json()).then(response => {
            if (response.code === 200) {
                toast.update(id, { render: response.message, type: "success", isLoading: false, autoClose: 3000 })
                setLoading(false);
                handleCloseSuccess();
            } else {
                toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000 })
                setTimeout(() => {
                    setLoading(false);
                }, 3000)
            }
        })
    }

    return (
        <div className="container pr-10 pl-10">
            <div className="p-5">
                <DialogTitle className="text-center " id="alert-dialog-title"><span className="text-primary">{data._id ? ("Update ") : ("Add ")}</span>FirmWare Details</DialogTitle>
                <hr className="solid mt-0 mb-5"></hr>
                <form onSubmit={data._id ? onFormUpdate : onFormAdd} className="mx-auto">
                    <div className="row mx-auto">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="col-sm-6 col-form-label">Title</label>
                                <input className="form-control col-sm-12" type="text"
                                    placeholder="Title"
                                    maxLength={50}
                                    defaultValue={data._id ? (formData.vTitle) : ("")}
                                    onInvalid={(e) => e.target.setCustomValidity('Enter the Title')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setFormData({ ...formData, vTitle: e.target.value })} required></input>
                            </div>
                            <div className="form-group">
                                <label className="col-sm-6 col-form-label">Description</label>
                                <input className="form-control col-sm-12" type="text"
                                    maxLength={50}
                                    placeholder="Description"
                                    defaultValue={data._id ? (formData.vDescription) : ("")}
                                    onInvalid={(e) => e.target.setCustomValidity('Enter the Description')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setFormData({ ...formData, vDescription: e.target.value })} required></input>
                            </div>
                            <div className="form-group">
                                <div className={data?._id ? "disable form-group" : "form-group mb-1"}>
                                    <label className="col-sm-12 col-form-label">Product Group</label>
                                    <select
                                        className="form-control form-select"
                                        defaultValue={data._id ? (data.vProductGroup) : ("")}
                                        onInvalid={(e) => e.target.setCustomValidity('Select Product Group')}
                                        onInput={(e) => e.target.setCustomValidity('')}
                                        onChange={(e) => setFormData({ ...formData, vProductGroup: e.target.value })}
                                        disabled={data._id}
                                        required>
                                        <option value="" disabled> Select </option>
                                        <option value="smartouch_4M" disabled={group.includes("smartouch_4M")}>SmarTouch 4M</option>
                                        <option value="smartouch_8M" disabled={group.includes("smartouch_8M")}>SmarTouch 8M</option>
                                        <option value="smartack" disabled={group.includes("smartack")}>SmarTack</option>
                                        <option value="smartap_1_15A" disabled={group.includes("smartap_1_15A")}>SmarTap 15A</option>
                                        <option value="smartap_1_5A" disabled={group.includes("smartap_1_5A")}>SmarTap 5A</option>
                                        <option value="smartap_4M" disabled={group.includes("smartap_4M")}>SmarTap 4M</option>
                                        <option value="smartap_8M" disabled={group.includes("smartap_8M")}>SmarTap 8M</option>
                                    </select>
                                </div>
                                <div className={data._id ? "d-none" : "text-muted form-group pl-3"}>Note: Delete from list to enable the option</div>


                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="col-sm-6 col-form-label">Version</label>
                                <input className="form-control col-sm-12" type="text"
                                    placeholder="0.0.0"
                                    defaultValue={data._id ? (formData.vVersion) : ("")}
                                    onInvalid={(e) => e.target.setCustomValidity('Enter the Version')}
                                    onInput={(e) => e.target.setCustomValidity('')}
                                    onChange={(e) => setFormData({ ...formData, vVersion: e.target.value })} required></input>
                            </div>

                            <div className="form-group">
                                <label className="col-sm-12 col-form-label">File <span className="text-muted">( Max : 2MB )</span></label>
                                <input className="form-control col-sm-12" type="file" accept=".zip,.bin"
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                    required
                                ></input>
                            </div>
                            <div className=" form-group">
                                <label className="col-sm-4 col-form-label">Status</label>
                                <div className="col-sm-8">
                                    <FormControlLabel value="top"
                                        control={<Switch
                                            defaultChecked={data.tiStatus}
                                            onChange={(e, value) => setFormData({ ...formData, tiStatus: Number(value) })}
                                            name="status"
                                            color="primary" />}
                                        label=""
                                        labelPlacement="end" />
                                    <span className={formData.tiStatus ? ("col-form-label text-success ") : ("col-form-label text-danger ")}
                                    >
                                        {formData.tiStatus ? ("Active") : ("Inactive")}</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row form-group mt-3 justify-content-sm-center">
                        <Button type="submit" disabled={loading} className="col-sm-4 btn btn-light-primary px-9 py-3 my-3">
                            <span>Submit</span>
                            {loading && <span className="ml-3 spinner spinner-dark"></span>}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    )
}
